import { SvgIconBase } from '../utils/types';

export default function Mentors({
  width = '24',
  height = '24',
  className = 'fill-current',
}: SvgIconBase) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="share-knowledge">
        <path
          id="Vector"
          d="M2.73828 4.5C2.73828 2.70407 4.19596 1.25 5.99184 1.25C7.78773 1.25 9.2454 2.70407 9.2454 4.5C9.2454 6.29593 7.78773 7.75 5.99184 7.75C4.19596 7.75 2.73828 6.29593 2.73828 4.5Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_2"
          d="M10.3362 10.2671C10.6148 10.5463 10.75 10.9173 10.75 11.2809C10.75 12.0922 10.0922 12.75 9.28085 12.75H2.71392C1.90542 12.75 1.25 12.0946 1.25 11.2861C1.25 10.9151 1.39121 10.5376 1.68015 10.2579C2.92651 9.05165 4.43767 8.38926 5.98919 8.37523C7.54499 8.36115 9.07137 8.99999 10.3362 10.2671Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_3"
          d="M14.7383 14.5C14.7383 12.7041 16.1959 11.25 17.9918 11.25C19.7877 11.25 21.2454 12.7041 21.2454 14.5C21.2454 16.2959 19.7877 17.75 17.9918 17.75C16.1959 17.75 14.7383 16.2959 14.7383 14.5Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_4"
          d="M22.3362 20.2671C22.6148 20.5463 22.75 20.9173 22.75 21.2809C22.75 22.0922 22.0922 22.75 21.2809 22.75H14.7139C13.9054 22.75 13.25 22.0946 13.25 21.2861C13.25 20.9151 13.3912 20.5376 13.6802 20.2579C14.9265 19.0517 16.4377 18.3893 17.9892 18.3752C19.545 18.3612 21.0714 19 22.3362 20.2671Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_5"
          d="M5 14.75C5 14.1977 4.55228 13.75 4 13.75C3.44772 13.75 3 14.1977 3 14.75C3 19.1723 6.57772 22.75 11 22.75C11.3466 22.75 11.6684 22.5705 11.8507 22.2757C12.0329 21.9809 12.0494 21.6128 11.8944 21.3028L10.8944 19.3028C10.6474 18.8088 10.0468 18.6086 9.55279 18.8556L8.29808 20.1103C6.34038 19.1231 5 17.0953 5 14.75Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          id="Vector_6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 2.25C14 1.69772 14.4477 1.25 15 1.25H21C21.5523 1.25 22 1.69772 22 2.25C22 2.80228 21.5523 3.25 21 3.25H15C14.4477 3.25 14 2.80228 14 2.25ZM14 5.25C14 4.69772 14.4477 4.25 15 4.25H21C21.5523 4.25 22 4.69772 22 5.25C22 5.80228 21.5523 6.25 21 6.25H15C14.4477 6.25 14 5.80228 14 5.25ZM14 8.25C14 7.69772 14.4477 7.25 15 7.25H18.5C19.0523 7.25 19.5 7.69772 19.5 8.25C19.5 8.80228 19.0523 9.25 18.5 9.25H15C14.4477 9.25 14 8.80228 14 8.25Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
      </g>
    </svg>
  );
}
